import { REDUX_STORE } from '@funnels/constants';
import {
  BrokerInterviews,
  ClearBrokerInterviewsErrorAction,
  DeleteBrokerInterviewsAction,
  DeleteBrokerInterviewsFailAction,
  DeleteBrokerInterviewsSuccessAction,
  FetchBrokerInterviewsAction,
  FetchBrokerInterviewsFailAction,
  FetchBrokerInterviewsSuccessAction,
  ServerBrokerInterviewFetch,
  UpsertBrokerInterviewsAction,
  UpsertBrokerInterviewsFailAction,
  UpsertBrokerInterviewsSuccessAction,
} from '@funnels/types';

export function clearBrokerInterviewsError(): ClearBrokerInterviewsErrorAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.CLEAR_BROKER_INTERVIEWS_ERROR };
}

export function deleteBrokerInterviews(applicationId: string, clientId: string): DeleteBrokerInterviewsAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.DELETE_BROKER_INTERVIEWS,
    applicationId,
    clientId,
  };
}

export function deleteBrokerInterviewsFail(
  clientId: string,
  message: string = 'Unknown error'
): DeleteBrokerInterviewsFailAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_FAIL, clientId, message };
}

export function deleteBrokerInterviewsSuccess(): DeleteBrokerInterviewsSuccessAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_SUCCESS };
}

export function fetchBrokerInterviews(applicationId: string): FetchBrokerInterviewsAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.FETCH_BROKER_INTERVIEWS, applicationId };
}

export function fetchBrokerInterviewsFail(message: string = 'Unknown error'): FetchBrokerInterviewsFailAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_FAIL, message };
}

export function fetchBrokerInterviewsSuccess(
  brokerInterviews: ServerBrokerInterviewFetch[]
): FetchBrokerInterviewsSuccessAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_SUCCESS, brokerInterviews };
}

export function upsertBrokerInterviews(
  applicationId: string,
  brokerInterviews: BrokerInterviews[]
): UpsertBrokerInterviewsAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS,
    applicationId,
    brokerInterviews,
  };
}

export function upsertBrokerInterviewsFail(message: string = 'Unknown error'): UpsertBrokerInterviewsFailAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_FAIL, message };
}

export function upsertBrokerInterviewsSuccess(brokerInterview: BrokerInterviews): UpsertBrokerInterviewsSuccessAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_SUCCESS, brokerInterview };
}
